import React, { useState } from "react"
import { graphql, Link } from "gatsby"
//components
import { Bio } from "../components/bio/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Categorys from "../components/Categorys"
import Icon from "../components/icon/Icon"
import { Pagination, pageNationFormula } from "@thunder_fury/react-components"
import Posts from "../components/Post"
//Plugin
import styled from "styled-components"
import { ArticleListBox, ArticleContainer, TagTitle } from "../styles/global"
import { Pagenation } from '../styles/block'
import { Color } from "../styles/color"

export interface tagPostTemplateProps {
  data?: any
  location: string
}
export const tagPostTemplate: React.FC<tagPostTemplateProps> = ({
  data,
  location,
}) => {
  const post = data.contentfulPost
  // const blogTags = data.contentfulPost.tags
  const siteTitle = data.site.siteMetadata?.title || ``
  const tagPosts = data.contentfulTag.post
  const [currentPage, setCurrentPage] = useState(1)
  const pageInfo: { [key: string]: number } = pageNationFormula(
    tagPosts,
    currentPage,
    5,
    1
  )
  const paginate: (pageNumber: number) => void = (pageNumber: number) =>
    setCurrentPage(pageNumber)
  const currentPosts: any = pageInfo.currentPosts
  return (
    <Layout location={location} title={siteTitle}>
      <SEO title={data.contentfulTag.name} />
      <ArticleListBox>
        <TagTitle>
          <Icon icon={`category`} width={15} height={15} /> Tag`s{" "}
        </TagTitle>
        <Categorys />
        <ArticleContainer style={{ listStyle: `none` }}>
          <article itemScope itemType={`http://schema.org/Article`}>
            <ArticleNum itemProp={`headline`}>
              {data.contentfulTag.post ? (
                <>
                  {data.contentfulTag.name} 関連記事 ({" "}
                  {data.contentfulTag.post.length} ) 件
                </>
              ) : (
                <>{data.contentfulTag.name}の記事(０)件</>
              )}
            </ArticleNum>
            <Posts body={true} nodeWithout={true} posts={currentPosts} />
            <Pagenation.numbers>
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                paginate={paginate}
                totalPage={pageInfo.totalPage}
                startPage={pageInfo.startPage}
                endPage={pageInfo.endPage}
                upperPageBound={1}
                backgroundColor={`${Color.black}`}
                firstAndLast={true}
                borderRound={20}
              />
            </Pagenation.numbers>
          </article>
        </ArticleContainer>
      </ArticleListBox>
    </Layout>
  )
}

const ArticleNum = styled.div`
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: ${Color.dark};
  padding: 5px;
`

export default tagPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $slug: String! # $previousPostId: String # $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulTag(slug: { eq: $slug }) {
      name
      slug
      post {
        slug
        title
        image {
          file {
            url
          }
        }
        content {
          childMarkdownRemark {
            excerpt
          }
        }
        tags {
          slug
          name
        }
        createdAt(formatString: "YYYY.MM.DD")
        updatedAt(formatString: "YYYY.MM.DD")
      }
    }
  }
`
